import { changeHTMLAttribute } from './utils';
import {
    changeModeAction as changeModeActionApi
} from './reducer';

/**
 * Changes the topbar themes
 * @param {*} param0
 */
export const changeModeAction = (mode: string) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-mode", mode);
        dispatch(changeModeActionApi(mode));
    } catch (error) {

    }
};